<rt-dropdown-header>
  @if (showBackButton()) {
    <rt-icon-button
      (click)="onBack($event)"
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
  }
  <span>{{ skill().name }}</span>
</rt-dropdown-header>
<span class="panel-subtitle">
  {{
    'tlc.positions.position_details_dialog.tabs.skills.proficiency.subtitle'
      | translate: { positionName: positionName() }
  }}
</span>
<div class="proficiency-list">
  @for (proficiency of skill().proficiencies; track proficiency.id) {
    <rt-dropdown-item (click)="proficiencySelected.emit(proficiency)" [hasDivider]="true">
      <div class="proficiency-item">
        <div class="proficiency-dots">
          @for (dot of skill().proficiencies; track dot.id) {
            <span class="dot" [class.filled]="dot.position <= proficiency.position"></span>
          }
        </div>
        <div class="proficiency-text">
          <span class="proficiency-name">{{ proficiency.name }}</span>
          @if (proficiency.descriptionText) {
            <span class="proficiency-description">{{ proficiency.descriptionText }}</span>
          }
        </div>
      </div>
    </rt-dropdown-item>
  }
</div>
